import React from "react";
import { logout } from "../util/auth";

type Props = { className?: string };

const LogoutButton: React.FC<Props> = ({ className }) => {
  return (
    <button
      onClick={() => logout()}
      className={`app-button danger-outline small ${className ?? ""}`.trim()}
    >
      Log out
    </button>
  );
};

export default LogoutButton;
